(function($) {
  var carousels = document.querySelectorAll('.js-carousel')
  Array.prototype.forEach.call( carousels, el => {
    var images = el.querySelectorAll('img').length
    var carousel = new Swiper(el, {
      loop: images > 1,
      simulateTouch: images > 1,
      autoplay: false,
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      },
      navigation: {
        prevEl: '.swiper-navigation-prev',
        nextEl: '.swiper-navigation-next'
      }
    })
  
    if (images > 1) {
      inViewport(carousel.el, elt => {
        elt.swiper.autoplay.start();
      })
    }
  })

  var fadeCarousels = document.querySelectorAll('.js-carousel-fade');
  Array.prototype.forEach.call( fadeCarousels, el => {
    var images = el.querySelectorAll('img').length
    var carousel = new Swiper(el, {
      resistance: false,
      effect: 'fade',
      loop: images > 1,
      simulateTouch: images > 1,
      autoplay: false,
      fadeEffect: {
        crossFade: true
      },
      pagination: {
        el: images > 1 ? '.swiper-pagination' : null,
        clickable: true
      }
    })
  
    if (images > 1) {
      inViewport(carousel.el, elt => {
        elt.swiper.autoplay.start();
      })
    }
  } );
})(jQuery);